import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { Capacitor } from '@capacitor/core'
import AdminLayout from '@/layout/AdminLayout.vue'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { title: 'Ulgama girmek', guestOnly: true }
  },
  {
    path: '/admin/login',
    redirect: '/login'
  },
  {
    path: '/',
    redirect: '/admin'
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      {
        path: '',
        redirect: () => {
          const auth = useAuthStore()
          if (auth.isTeacher || auth.isReception) return '/admin/classes'
          return '/admin/dashboard'
        }
      },
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/BirthdayView.vue'),
        meta: { title: 'Doglan günleri (Dashboard)' }
      },
      {
        path: 'dashboard/birthday',
        component: () => import('@/views/dashboard/BirthdayView.vue'),
        meta: { title: 'Doglan günleri' }
      },
      // Classes
      {
        path: 'classes',
        component: () => import('@/views/classes/ClassesView.vue'),
        meta: { title: 'Synplar' }
      },
      {
        path: 'classes/:id(\\d+)',
        component: () => import('@/views/classes/ClassDetailView.vue'),
        meta: { title: 'Synp maglumaty' }
      },
      {
        path: 'classes/:id(\\d+)/exams',
        component: () => import('@/views/classes/exams/ClassExamsView.vue'),
        meta: { title: 'Synaglar' }
      },
      {
        path: 'classes/:classId(\\d+)/exams/create',
        component: () => import('@/views/classes/exams/ExamEditView.vue'),
        meta: { title: 'Täze synag' }
      },
      {
        path: 'classes/:classId(\\d+)/exams/edit/:examId(\\d+)',
        component: () => import('@/views/classes/exams/ExamEditView.vue'),
        meta: { title: 'Synag üýtgetmek' }
      },
      {
        path: 'classes/:id(\\d+)/attendances',
        component: () => import('@/views/classes/attendances/ClassAttendancesView.vue'),
        meta: { title: 'Gatnaşyklar' }
      },
      {
        path: 'classes/:classId(\\d+)/attendances/create',
        component: () => import('@/views/classes/attendances/AttendanceEditView.vue'),
        meta: { title: 'Täze gatnaşyk' }
      },
      {
        path: 'classes/:classId(\\d+)/attendances/edit/:attendanceId(\\d+)',
        component: () => import('@/views/classes/attendances/AttendanceEditView.vue'),
        meta: { title: 'Gatnaşygy üýtgetmek' }
      },
      {
        path: 'classes/create',
        component: () => import('@/views/classes/ClassEditView.vue'),
        meta: { title: 'Täze synp' }
      },
      {
        path: 'classes/edit/:id',
        component: () => import('@/views/classes/ClassEditView.vue'),
        meta: { title: 'Synpy üýtgetmek' }
      },
      // Academic References
      {
        path: 'stages',
        component: () => import('@/views/references/StagesView.vue'),
        meta: { title: 'Tapgyrlar' }
      },
      {
        path: 'shifts',
        component: () => import('@/views/references/ShiftsView.vue'),
        meta: { title: 'Smenalar' }
      },
      {
        path: 'branches',
        component: () => import('@/views/references/BranchesView.vue'),
        meta: { title: 'Şahamçalar' }
      },
      {
        path: 'rooms',
        component: () => import('@/views/references/RoomsView.vue'),
        meta: { title: 'Otaglar' }
      },
      {
        path: 'categories',
        component: () => import('@/views/references/CategoriesView.vue'),
        meta: { title: 'Kategoriýalar' }
      },
      {
        path: 'subjects',
        component: () => import('@/views/references/SubjectsView.vue'),
        meta: { title: 'Dersler' }
      },
      {
        path: 'relatives',
        component: () => import('@/views/references/RelativesView.vue'),
        meta: { title: 'Hossarlar' }
      },
      // Students
      {
        path: 'students',
        component: () => import('@/views/students/StudentsView.vue'),
        meta: { title: 'Talyplar' }
      },
      {
        path: 'students/:id(\\d+)',
        component: () => import('@/views/students/StudentDetailView.vue'),
        meta: { title: 'Talyp maglumaty' }
      },
      {
        path: 'students/create',
        component: () => import('@/views/students/StudentEditView.vue'),
        meta: { title: 'Täze talyp' }
      },
      {
        path: 'students/edit/:id',
        component: () => import('@/views/students/StudentEditView.vue'),
        meta: { title: 'Talyp üýtgetmek' }
      },
      {
        path: 'students/viewclasses/:id',
        component: () => import('@/views/students/StudentClassesView.vue'),
        meta: { title: 'Talybyň synplary' }
      },
      // Invoices & Reports
      {
        path: 'invoices',
        component: () => import('@/views/invoices/InvoicesView.vue'),
        meta: { title: 'Tölegler' }
      },
      {
        path: 'invoices/edit/:id(\\d+)',
        component: () => import('@/views/invoices/InvoiceEditView.vue'),
        meta: { title: 'Faktura üýtgetmek' }
      },
      {
        path: 'invoices/create-for-class/:classStudentId(\\d+)',
        component: () => import('@/views/invoices/InvoiceEditView.vue'),
        meta: { title: 'Faktura döretmek' }
      },
      {
        path: 'invoices/prices',
        component: () => import('@/views/invoices/PricesView.vue'),
        meta: { title: 'Nyrhlar' }
      },
      {
        path: 'reports/general',
        component: () => import('@/views/reports/GeneralReportView.vue'),
        meta: { title: 'Umumy hasabat' }
      },
      {
        path: 'reports/books',
        component: () => import('@/views/reports/BooksReportView.vue'),
        meta: { title: 'Kitaplar hasabaty' }
      },
      {
        path: 'reports/attendances',
        component: () => import('@/views/reports/AttendancesReportView.vue'),
        meta: { title: 'Gatnaşyk hasabaty' }
      },
      {
        path: 'reports/performance',
        component: () => import('@/views/reports/PerformanceReportView.vue'),
        meta: { title: 'Başarnyk hasabaty' }
      },
      {
        path: 'reports/stages',
        component: () => import('@/views/reports/StagesReportView.vue'),
        meta: { title: 'Tapgyrlar hasabaty' }
      },
      {
        path: 'reports/salaries',
        component: () => import('@/views/reports/SalariesReportView.vue'),
        meta: { title: 'Zähmet haky hasabaty' }
      },
      {
        path: 'reports/duplicate-cards',
        component: () => import('@/views/reports/DuplicateCardsReportView.vue'),
        meta: { title: 'Iki gezek açylan kartoçkalar' }
      },
      {
        path: 'reports/invoices',
        component: () => import('@/views/reports/DailyInvoicesReportView.vue'),
        meta: { title: 'Gündelik hasabat' }
      },
      {
        path: 'reports/unpaid-students',
        component: () => import('@/views/reports/UnpaidStudentsReportView.vue'),
        meta: { title: 'Töleg etmedik talyplar' }
      },
      {
        path: 'reports/catering',
        component: () => import('@/views/reports/CateringReportView.vue'),
        meta: { title: 'Naharhana hasabaty' }
      },
      {
        path: 'classes/details/:id(\\d+)',
        redirect: to => `/admin/classes/${to.params.id}`
      },
      {
        path: 'students/details/:id(\\d+)',
        redirect: to => `/admin/students/${to.params.id}`
      },
      // CMS
      {
        path: 'cms/hero',
        component: () => import('@/views/cms/BannersView.vue'),
        meta: { title: 'Bannerler (Hero)' }
      },
      {
        path: 'cms/banners',
        redirect: '/admin/cms/hero'
      },
      {
        path: 'cms/gallery',
        component: () => import('@/views/cms/GalleryView.vue'),
        meta: { title: 'Galereýa' }
      },
      {
        path: 'cms/siteevents',
        component: () => import('@/views/cms/SiteEventsView.vue'),
        meta: { title: 'Çäreler' }
      },
      {
        path: 'cms/eventregistrations',
        component: () => import('@/views/cms/EventRegistrationsView.vue'),
        meta: { title: 'Ýazgylar' }
      },
      {
        path: 'cms/registrations',
        redirect: '/admin/cms/eventregistrations'
      },
      {
        path: 'cms/blog',
        component: () => import('@/views/cms/BlogView.vue'),
        meta: { title: 'Blog makalalary' }
      },
      {
        path: 'cms/blog/create',
        component: () => import('@/views/cms/BlogEditView.vue'),
        meta: { title: 'Täze makala ýazmak' }
      },
      {
        path: 'cms/blog/edit',
        component: () => import('@/views/cms/BlogEditView.vue'),
        meta: { title: 'Täze makala ýazmak' }
      },
      {
        path: 'cms/blog/edit/:id',
        component: () => import('@/views/cms/BlogEditView.vue'),
        meta: { title: 'Makalany üýtgetmek' }
      },
      {
        path: 'cms/comments',
        component: () => import('@/views/cms/CommentsView.vue'),
        meta: { title: 'Teswirler' }
      },
      {
        path: 'cms/feedback',
        component: () => import('@/views/cms/FeedbackView.vue'),
        meta: { title: 'Habarlar (Feedback)' }
      },
      {
        path: 'cms/testresults',
        component: () => import('@/views/cms/TestResultsView.vue'),
        meta: { title: 'Test netijeleri' }
      },
      {
        path: 'cms/videos',
        component: () => import('@/views/cms/VideosView.vue'),
        meta: { title: 'Wideolar' }
      },
      {
        path: 'cms/localization',
        component: () => import('@/views/cms/LocalizationView.vue'),
        meta: { title: 'Terjimeler (Localization)' }
      },
      {
        path: 'cms',
        redirect: '/admin/cms/hero'
      },
      // Dcoin
      {
        path: 'dcoin',
        component: () => import('@/views/dcoin/DcoinView.vue'),
        meta: { title: 'Dcoin dolandyryş' }
      },
      // Timetable & QR
      {
        path: 'events',
        component: () => import('@/views/timetable/TimetableView.vue'),
        meta: { title: 'Sapak tertibi' }
      },
      {
        path: 'asctimetables',
        component: () => import('@/views/timetable/TimetableView.vue'),
        meta: { title: 'AscTimetable Import' }
      },
      {
        path: 'qrcodescanner',
        component: () => import('@/views/qrcodescanner/QrScannerView.vue'),
        meta: { title: 'QR Scanner' }
      },
      // SMS Gateway
      {
        path: 'sms',
        component: () => import('@/views/sms/SmsCenterView.vue'),
        meta: { title: 'SMS Merkezi' },
        beforeEnter: (to, from, next) => {
          const auth = useAuthStore()
          if (auth.isAdmin || auth.isReception) {
            next()
          } else {
            next('/admin')
          }
        }
      },
      // Users & Administration
      {
        path: 'users',
        component: () => import('@/views/admin/UsersView.vue'),
        meta: { title: 'Ulanyjylar' }
      },
      {
        path: 'users/create',
        component: () => import('@/views/admin/UserEditView.vue'),
        meta: { title: 'Täze ulanyjy goşmak' }
      },
      {
        path: 'users/edit/:id(\\d+)',
        component: () => import('@/views/admin/UserEditView.vue'),
        meta: { title: 'Ulanyjy maglumaty' }
      },
      {
        path: 'roles',
        component: () => import('@/views/admin/RolesView.vue'),
        meta: { title: 'Hukuklar' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: to => {
      if (Capacitor.isNativePlatform() || to.path === '/') {
        return '/admin'
      }
      if (!to.path.startsWith('/admin')) {
        window.location.href = to.fullPath
        return to.fullPath
      }
      return '/admin/dashboard'
    }
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    return { top: 0, left: 0 }
  }
})

router.beforeEach(async (to, _from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - Dury zehin Admin`
  }

  const authStore = useAuthStore()
  if (!authStore.user && authStore.isLoading) {
    await authStore.fetchUser()
  }

  // Allow guest access to login page
  if (to.path === '/login') {
    if (authStore.isAuthenticated) {
      return next('/admin')
    }
    return next()
  }

  // Protect all other routes
  if (!authStore.isAuthenticated) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  // Teacher route restrictions
  if (authStore.isTeacher) {
    const isAllowedForTeacher =
      to.path === '/admin/classes' ||
      to.path.startsWith('/admin/classes/')

    if (!isAllowedForTeacher) {
      return next('/admin/classes')
    }
  }

  // Reception route restrictions
  if (authStore.isReception) {
    const isAllowedForReception =
      to.path === '/admin/classes' ||
      to.path === '/admin/classes/create' ||
      to.path.startsWith('/admin/classes/') ||
      to.path === '/admin/students' ||
      to.path.startsWith('/admin/students/') ||
      to.path === '/admin/dashboard' ||
      to.path === '/admin/dashboard/birthday' ||
      to.path === '/admin/invoices' ||
      to.path.startsWith('/admin/invoices/') ||
      to.path === '/admin/reports/invoices' ||
      to.path === '/admin/reports/unpaid-students'

    if (!isAllowedForReception) {
      return next('/admin/classes')
    }
  }

  next()
})

router.afterEach(() => {
  const appStore = useAppStore()
  appStore.closeMobileSidebar()

  // Always scroll window and layout containers to the very top on navigation
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  const mainContent = document.querySelector('.admin-content')
  if (mainContent) mainContent.scrollTop = 0
  const adminMain = document.querySelector('.admin-main')
  if (adminMain) adminMain.scrollTop = 0

  // Ensure scroll is reset once async view chunks render
  setTimeout(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }, 0)
})

export default router

